import { createStore } from 'vuex'
import axios from 'axios'

const storedDogs = window.localStorage.getItem('selectedDog');

export default createStore({
  state: {
    dogimages: [],
    noBreedFound: false,
    breed: "",
    isLoading: false,
    selectedDog: storedDogs ? JSON.parse(storedDogs) : {}
  },
  getters: {
    dogimages: state => state.dogimages,
    noBreedFound: state => state.noBreedFound,
    breed: state => state.breed,
    isLoading: state => state.isLoading,
    selectedDog: state => state.selectedDog
  },
  mutations: {
    setDogImages(state, dogimages) {
      state.dogimages = dogimages
    },
    setNoBreedFound(state, noBreedFound) {
      state.noBreedFound = noBreedFound
    },
    setBreed(state, breed) {
      state.breed = breed
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    setSelectedDog(state, selectedDog) {
      state.selectedDog = selectedDog
    }
  },
  actions: {
    getBreed({ commit, state }) {
      commit('setIsLoading', true)
      localStorage.getItem('randomDogs');
      axios.get(`https://dog.ceo/api/breed/${state.breed.toLowerCase()}/images/random/100`)
        .then((res) => {
          commit('setIsLoading', false)
          if (res.data.message.length) {
            commit('setNoBreedFound', false)
            localStorage.setItem('randomDogs', JSON.stringify(res.data.message))
            commit('setDogImages', res.data.message)
          } else {
            commit('setNoBreedFound', true)
          }
        }).catch((err) => {
          console.log(err)
          commit('setBreed', "")
          commit('setNoBreedFound', true)
        })
    },
    fetchRandomDogs({ commit }) {
      commit('setIsLoading', true)
      const storedDogs = localStorage.getItem('randomDogs');
      if (storedDogs) {
        commit('setIsLoading', false)
        commit('setDogImages', JSON.parse(storedDogs));
      } else {
        axios.get('https://dog.ceo/api/breed/hound/images/random/100', {
          // timeout: 5000
        })
          .then((res) => {
            commit('setIsLoading', false)
            localStorage.setItem('randomDogs', JSON.stringify(res.data.message));
            commit('setDogImages', res.data.message)
          })
          .catch(err => console.error(err))
      }
    },
    setSelectedDog({ commit }, selectedDog) {
      localStorage.setItem('selectedDog', JSON.stringify(selectedDog))
      commit("setSelectedDog", selectedDog);
    },
  },
  modules: {
  }
})
